import React, { Component } from 'react';
import {baseUrl} from './url';
import xsmallLoader from '../assets/loader-xs.svg';

class AssignPatient extends Component{
    constructor(props){
        super(props)
        this.state = {
            patient_id: this.props.id,
            patient_name:  this.props.name,
            caregivers: [],
            caregiver_name: '',
            caregiver_nameError: '',
            response: true
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount(){
        let caregivers = [];
        let retries = 0;
        const token = localStorage.getItem('access_token');
        fetch(`${baseUrl}/admin/caregivers/available`,{
            method: 'GET',
            headers: {
                'Authorization': token
            }
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            return response.json();
        })
        .then((responseJson) => {
            caregivers = responseJson.data.map((caregiver) => {
                return caregiver
            });
            this.setState({
                caregivers: caregivers
            })
        })
        .catch((error)=>{
            console.log(error);
            if (error === 401 && retries < 1){
                localStorage.getItem('access_token')
                .then(value => {
                    fetch(`${baseUrl}/token/refresh`,{
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': value
                        }
                    }).then(response => {
                        retries += 1;
                        if(response.status === 200){
                            localStorage.setItem('access_token', response.headers.get('Authorization'));
                            this.handleSubmit();
                        }
                        else{
                            alert('something went wrong please try again later');
                        }
                    })
                })
            }
			else if (error instanceof TypeError){
				console.log(error);
			}
            else{
                alert('something went wrong please try again later');
            }
        })
    }
    handleChange(e){
        if(e.target.name === 'caregiver_name'){
            this.state.caregivers.forEach(caregiver => {
                if(caregiver.name === e.target.value){
                    this.setState({
                        caregiver_id: caregiver.id,
                        caregiver_name: caregiver.name,
                        caregiver_nameError: '',
                    })
                }
            })
        }
    }
    handleSubmit(e){
        e.preventDefault();
        const {caregiver_id, patient_id, caregiver_nameError } = this.state;
        if(!caregiver_id){
            this.setState({
                caregiver_nameError: 'Please choose a new caregiver'
            })
        }

        if(!caregiver_nameError){
            let retries = 0;
            const token = localStorage.getItem('access_token');
            this.setState({
                response: false
            })
            fetch(`${baseUrl}/admin/patients/reassign`,{
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
                body:JSON.stringify({
                    "patient_id": patient_id,
                    "caregiver_id": caregiver_id
                })
            })
            .then((response) => {
                const auth = response.headers.get('Authorization');
                localStorage.setItem('access_token', auth);
                return response.json();
            })
            .then((responseJson) => {
                if(responseJson._meta._status === 202){
                    this.setState({
                        responseMessage: responseJson.message,
                        response: true
                    })
                }else{
                    this.setState({
                        errorMessage: "Something went wrong, Please try again later",
                        response: true
                    })
                }
            })
            .catch((error)=>{
                console.log(error);
                if (error === 401 && retries < 1){
                    localStorage.getItem('access_token')
                    .then(value => {
                        fetch(`${baseUrl}/token/refresh`,{
                            headers: {
                                'Accept': 'application/json',
                                'Authorization': value
                            }
                        }).then(response => {
                            retries += 1;
                            if(response.status === 200){
                                localStorage.setItem('access_token', response.headers.get('Authorization'));
                                this.handleSubmit();
                            }
                            else{
                                alert('something went wrong please try again later');
                            }
                        })
                    })
                }
                else{
                    alert('something went wrong please try again later');
                }
            })
        }
    }
    render(){

        let { caregivers } = this.state;
        let caregiverOption = caregivers.map((caregiver) => 
            <option key={caregiver.id}>{caregiver.name}</option>
        )

        return(
            <div>
                {
                    !this.state.responseMessage && !this.state.errorMessage &&
                    <div className="assign-patient">
                        <h4>Assign New Caregiver</h4>
                        <form onSubmit={this.handleSubmit}>
                            <label>
                                Patient
                                <input type="text" value={this.state.patient_name} disabled/>
                            </label>
                            <label>
                                New Caregiver
                                    <select 
                                        name="caregiver_name" 
                                        className={this.state.caregiver_nameError && 'error-input'} 
                                        onChange={this.handleChange}
                                        value={this.state.caregiver_name}>
                                        <option>Select...</option>
                                        {caregiverOption}
                                    </select>
                                    <span className="error-text">{this.state.caregiver_nameError}</span>
                            </label>
                            {!this.state.response && <div className="loader"><img src={xsmallLoader} alt=''/></div>}
                            <button type="submit">Change</button>
                        </form>
                    </div>
                }
                {
                    this.state.responseMessage &&
                    <div className="assign-patient">
                        <div className="check">
                            <div className="svg-div">
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                                    <circle className="path circle" fill="none" stroke="#14DA9E" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
                                    <polyline className="path check" fill="none" stroke="#14DA9E" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
                                </svg>
                            </div>
                            <p><small>{this.state.responseMessage}</small></p>
                        </div>
                    </div>
                }
                {
                    this.state.errorMessage &&
                    <div className="assign-patient">
                        <div className="check">
                            <div className="svg-div">
                                <svg className="error" xmlns="http://www.w3.org/2000/svg" viewBox="11433 755 28.429 28.429">
                                    <g transform="translate(11433 755)">
                                        <path className="a" d="M14.214,0A14.214,14.214,0,1,0,28.429,14.214,14.228,14.228,0,0,0,14.214,0Zm0,26.892A12.679,12.679,0,1,1,26.892,14.214,12.635,12.635,0,0,1,14.214,26.892Zm0,0"/>
                                        <path className="a" d="M69.973,80.737A1.537,1.537,0,1,1,68.437,79.2a1.532,1.532,0,0,1,1.537,1.537Zm0,0" transform="translate(-58.868 -69.692)"/>
                                        <path className="a" d="M149.173,80.737a1.537,1.537,0,1,1-1.537-1.537,1.532,1.532,0,0,1,1.537,1.537Zm0,0" transform="translate(-128.56 -69.692)"/>
                                        <path className="a" d="M63.955,143.4a8.93,8.93,0,0,0-7.455,4.046l1.3.828a7.317,7.317,0,0,1,12.281,0l1.3-.828a8.929,8.929,0,0,0-6.4-3.986,7.492,7.492,0,0,0-1.02-.06Zm0,0" transform="translate(-49.717 -126.184)"/>
                                    </g>
                                </svg>
                            </div>
                            <p><small>{this.state.errorMessage}</small></p>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default AssignPatient;


// WEBPACK FOOTER //
// ./src/components/AssignPatient.js